import { Card, CardBody, Col } from "reactstrap";
import { ModalTitle } from "../../../../constants";
import { BasicModalSubTitle } from "../../../../data/uiKits/Modal";
import CommonCardHeader from "../../../../coreComponents/CommonCardHeader";
import ScrollingModal from "./ScrollingModal";
import SimpleModal from "./SimpleModal";
import TooltipModal from "./tooltipModal";
import ThemeModal from "./themeModal";

const BasicModal = () => {
  return (
    <Col lg="6">
      <Card>
        <CommonCardHeader title={ModalTitle} span={BasicModalSubTitle} />
        <CardBody className="badge-spacing">
          <SimpleModal />
          <ScrollingModal />
          <TooltipModal />
          <ThemeModal />
        </CardBody>
      </Card>
    </Col>
  );
};
export default BasicModal;
